const scrollTo = () => {
  (function ($) {
    const $btn = $(".js-scroll");
    const hasButton = $(".js-scroll").length;
    const $htmlBody = $("html, body");

    if (!hasButton) {
      return;
    }

    $btn.on("click", function (e) {
      const href = e.target.href;
      const hasHash = href.includes("#");

      if (!hasHash) {
        return;
      }

      e.preventDefault();

      const target = this.hash;
      const $target = $(target);
      const $scrollTo = $target.offset().top;

      // anchor scrolling at even speed
      const distance = Math.abs($(window).scrollTop() - $scrollTo);
      const speed = distance / 2;

      $htmlBody.animate(
        {
          scrollTop: $($(this).attr("href")).offset().top,
        },
        speed,
        "linear"
      );
    });
  })(jQuery);
};

export default scrollTo;
